export default "__VITE_ASSET__CBf7t8Oj__"